module.exports = __webpack_public_path__ + "img/article-import-color.9b0e06db.svg";